import { Typography } from '@mui/material'
import { FC } from 'react'
import { Colors } from 'src/components/theme'

type TitleProps = {
  children: React.ReactNode
}
export const Title: FC<TitleProps> = ({ children }) => (
  <Typography fontSize={20} color={Colors.neutral700}>
    {children}
  </Typography>
)
